// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"ecd9ca09","638":"cd07da83","720":"ecd9ca09","848":"ce75c6a1"}[chunkId] + ".chunk.css";
};